import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { formatPrice, productMessage, waLink, categoryOf, accTypeOf, usesModels } from "@/lib/store";
import { useCart, isAccessory, useInterestClick } from "@/lib/cart";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const StickyBuyBar = ({ p, targetId = "product-actions" }) => {
  const [show, setShow] = useState(false);
  const { add, has, setOpen } = useCart();
  const interest = useInterestClick(p);
  const compat = Array.isArray(p?.compatible) ? p.compatible : [];
  const needsPick = categoryOf(p) === "acessorios" && usesModels(accTypeOf(p)) && compat.length > 1;
  const forModel = compat.length === 1 && usesModels(accTypeOf(p)) ? compat[0] : "";

  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => setShow(!e.isIntersecting), { threshold: 0 });
    io.observe(el);
    return () => io.disconnect();
  }, [targetId, p?.id]);

  const toActions = (e) => {
    e.preventDefault();
    document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  const onCart = (e) => {
    if (needsPick) return toActions(e);
    if (has(p, forModel) && !isAccessory(p)) return setOpen(true);
    return add(p, forModel);
  };

  return (
    <div data-testid="sticky-buy-bar" aria-hidden={!show}
      className={`fixed-bottom-extend fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0d0d0f]/90 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur-xl transition-[transform,visibility] duration-500 lg:hidden ${show ? "visible translate-y-0" : "pointer-events-none invisible translate-y-[calc(100%+180px)]"}`}>
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs text-zinc-400">{p.model}</p>
          <p data-testid="sticky-buy-price" className="font-display truncate text-xl font-extrabold leading-tight text-white">{formatPrice(p.price)}</p>
        </div>
        <button data-testid="sticky-buy-cart" onClick={onCart} aria-label="Adicionar ao carrinho" tabIndex={show ? 0 : -1}
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/20 text-white active:scale-95">
          <ShoppingBag className="h-5 w-5" />
        </button>
        <a data-testid="sticky-buy-interest" data-pid={p.id} data-pmodel={p.model} href={waLink(productMessage(p, forModel))} onClick={needsPick ? toActions : interest}
          target="_blank" rel="noopener noreferrer" tabIndex={show ? 0 : -1}
          className="flex h-12 shrink-0 items-center gap-2 rounded-full bg-[#25D366] px-5 text-sm font-bold text-black active:scale-95">
          <WhatsAppIcon className="h-4 w-4" /> Tenho interesse
        </a>
      </div>
    </div>
  );
};
